import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../theme";
import { Text } from "../text";
export const List = ({ ordered, items, listStyleType, className, ListItem, Label, }) => {
    // with deprecated ordered, provide listStyleType and make list ordered using <ol> element
    const Wrapper = ordered || listStyleType ? OrderedList : UnorderedList;
    return (_jsx(Wrapper, { className: className, listStyleType: listStyleType, children: items.map((item, index) => (_jsx(ListItem, { children: _jsx(Label, { children: item }) }, index))) }));
};
const ListItem = styled.li `
  font-size: 1.25em;
  line-height: 1.8em;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  padding-bottom: 1em;

  & & {
    font-size: 1em;
  }
`;
const Label = styled(({ children, ...props }) => (_jsx(Text, { fontWeight: "normal", ...props, children: children }))) ``;
List.defaultProps = {
    ordered: false,
    ListItem,
    Label,
};
const OrderedList = styled.ol `
  padding-left: 3em;
  list-style-position: outside;
  list-style-type: ${({ listStyleType }) => listStyleType};
`;
OrderedList.defaultProps = {
    listStyleType: "decimal",
};
const UnorderedList = styled.ul `
  padding-left: 2em;
  list-style-position: inside;
  list-style-type: ${({ listStyleType }) => listStyleType};
`;
UnorderedList.defaultProps = {
    listStyleType: "disc",
};
